const prefix = 'nxt';
const iconName = 'noteWithCheckmark';
const width = 26;
const height = 24;
const ligatures = [];
const unicode = '';
const svgPathData = [
  'M11.125 20.125H5.8125C4.86328 20.125 4.125 19.3867 4.125 18.4375V6.0625C4.125 5.14844 4.86328 4.375 5.8125 4.375H18.1875C19.1016 4.375 19.875 5.14844 19.875 6.0625V10.625L18.1875 12.3125V6.0625H5.8125V18.4375H9.4375L11.125 20.125ZM16.425 13.9375L16.5 14L16.5625 13.9375H16.425Z',
  'M16.0547 21.3125C16.2891 21.5469 16.6875 21.5469 16.9219 21.3125L23.8125 14.4219C24.0469 14.1875 24.0469 13.7891 23.8125 13.5547L22.9688 12.7109C22.7344 12.4766 22.3594 12.4766 22.125 12.7109L16.5 18.3359L13.8516 15.7109C13.6172 15.4766 13.2422 15.4766 13.0078 15.7109L12.1641 16.5547C11.9297 16.7891 11.9297 17.1875 12.1641 17.4219L16.0547 21.3125Z',
];

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtNoteWithCheckmark = definition;

export { definition, nxtNoteWithCheckmark, prefix, iconName, width, height, ligatures, unicode, svgPathData };
